import { ErrorParser } from "../ErrorParser";
import { isObject } from "lodash-es";

/**
 * Ej: 'Invalid extra score in payload (0)'
 */
export class PuntosExtraParser implements ErrorParser {
    public puedeLeerError(error: string): boolean {
        return !isObject(error) && error.includes("Invalid extra score") && error.includes("payload (0)");
    }

    public traducir(_error: string): string {
        return "No se puede poner 0 como puntos extras.";
    }
}
